import { isMyDocumentType } from 'neuro-schemas';
import { isByInformant } from './documentHandling';

/**
 * Narrows a set of document types down to my documents
 */
export type TMySubmittable<T extends TDocumentType> = Extract<T, TMyDocumentType>;

/**
 * Whether a document is a my document submitted by one of the patient's informants
 * @param d - Document to check or an empty object for a document that is being created
 * @param informants - Informants of the current patient
 * @returns True if the document is a my document by an informant
 */
export const isInformantSurvey = <T extends TDocumentType>(
  d: IDocumentWithTypeV2<T> | Record<string, never>,
  informants: Array<IInformant>,
): d is IDocumentWithTypeV2<TMySubmittable<T>> =>
  '_type' in d && isMyDocumentType(d._type) && isByInformant(d, informants);
